import { Link } from "react-router-dom";
import { formatBRL } from "@/lib/api";
import { Heart } from "lucide-react";

export default function ProductCard({ product }) {
  const price = product.sale_price ?? product.price;
  const hasSale = !!product.sale_price;
  const installment = (price / 3).toFixed(2).replace(".", ",");
  return (
    <Link
      to={`/produto/${product.slug || product.id}`}
      data-testid={`product-card-${product.id}`}
      className="product-card group block bg-white rounded-xl overflow-hidden border border-neutral-200/70"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-neutral-50">
        <img
          src={product.images?.[0] || "https://via.placeholder.com/600x750?text=Nalin"}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-2 left-2 flex flex-col gap-1">
          {product.is_new && (
            <span className="bg-[#181818] text-white text-[10px] font-bold px-2 py-0.5 rounded-full">NOVO</span>
          )}
          {hasSale && (
            <span className="bg-[#C91F1F] text-white text-[10px] font-bold px-2 py-0.5 rounded-full">
              -{Math.round(((product.price - product.sale_price) / product.price) * 100)}%
            </span>
          )}
        </div>
      </div>
      <div className="p-3 space-y-1">
        <h3 className="text-sm sm:text-base font-medium text-neutral-900 line-clamp-2 min-h-[2.5rem]">{product.name}</h3>
        <div className="flex items-baseline gap-2 flex-wrap">
          {hasSale && (
            <span className="text-xs text-neutral-400 line-through">{formatBRL(product.price)}</span>
          )}
          <span className="text-lg font-extrabold text-[#C91F1F]">{formatBRL(price)}</span>
        </div>
        <p className="text-xs text-neutral-500">ou 3x de R$ {installment} sem juros</p>
      </div>
    </Link>
  );
}
